import { useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Button } from "../components/ui/button";
import { api, errMsg } from "../lib/api";
import { PageHeader, LeadsTable, LeadDetail, FundDialog, Pager, useLoad } from "../components/common";

export default function SearchPage({ me }) {
  const isAdmin = me.role === "admin";
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [params, setParams] = useState({ q: "", status: "" });
  const [open, setOpen] = useState(null);
  const [fund, setFund] = useState(null);
  const [data, reload] = useLoad(async () => (await api.get("/leads", { params: { ...params, page } })).data, [params, page]);
  const go = (e) => { e.preventDefault(); setPage(1); setParams({ q, status }); };
  const suppress = async (l) => {
    const reason = window.prompt(`Reason to ${l.suppressed ? "unsuppress" : "suppress"} this lead?`);
    if (!reason) return;
    try { await api.post(`/leads/${l.id}/suppress`, { suppressed: !l.suppressed, reason }); toast.success("Updated"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="search-page">
      <PageHeader title={isAdmin ? "Master lead search" : "Search my leads"} sub={isAdmin ? "Every lead ever uploaded. Contact details are masked in lists." : "Only leads currently assigned to you (or your team) and funded deals you retain."} />
      <form onSubmit={go} className="flex flex-wrap gap-2 mb-4">
        <input className="fld flex-1 min-w-[240px]" placeholder="Business, contact name, phone or email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input" />
        <select className="fld" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="search-status-select">
          <option value="">All statuses</option>{["available", "team_allocated", "assigned", "funded"].map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
        </select>
        <Button type="submit" data-testid="search-submit-btn"><Search className="w-4 h-4 mr-1" />Search</Button>
      </form>
      <div className="panel">
        <LeadsTable items={data?.items} onOpen={setOpen} onFund={isAdmin ? null : setFund}
          extra={isAdmin ? (l) => <Button size="sm" variant="ghost" onClick={() => suppress(l)} data-testid={`lead-suppress-${l.id}`}>{l.suppressed ? "Unsuppress" : "Suppress"}</Button> : null} />
        {data && <Pager page={page} total={data.total} onPage={setPage} />}
      </div>
      <LeadDetail id={open} onClose={() => setOpen(null)} isAdmin={isAdmin} />
      {fund && <FundDialog lead={fund} open onClose={() => setFund(null)} onDone={reload} />}
    </div>
  );
}
